import dayjs, { dateTimeDisplayFormat } from '~libs/dayjs';

import { Column } from '~components/table-view-v3';
import ActionButtons from '~main/components/document-batch-jobs/ActionButtons';

export const columns: Column[] = [
  {
    id: 'reference',
    header: 'Reference',
    type: 'text',
    deriveValue: (row) => row.reference,
  },
  {
    id: 'status_id',
    header: 'Status',
    type: 'text',
    deriveValue: (row) => row.status?.name,
  },
  {
    id: 'created_at',
    header: 'Created',
    type: 'text',
    deriveValue: (row) => dayjs(row.created_at).format(dateTimeDisplayFormat),
  },
  {
    id: 'downloaded_at',
    header: 'Downloaded',
    type: 'text',
    deriveValue: (row) => (row.downloaded_at ? dayjs(row.downloaded_at).format(dateTimeDisplayFormat) : ''),
  },
  {
    id: 'total_jobs',
    header: 'Total Jobs',
    type: 'number',
    classNames: {
      header: 'cell-align-right',
      cell: 'cell-align-right',
    },
  },
  {
    id: 'completed_jobs',
    header: 'Completed Jobs',
    type: 'number',
    classNames: {
      header: 'cell-align-right',
      cell: 'cell-align-right',
    },
  },
  {
    id: 'failed_jobs',
    header: 'Failed Jobs',
    type: 'number',
    classNames: {
      header: 'cell-align-right',
      cell: 'cell-align-right',
    },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    style: { width: '150px' },
    component: ActionButtons,
  },
];
